import axios from 'axios'
import experienceSlidesCommon from '../../assets/journey/journey.json'
import session from './session'

// initial state
const state = {
  deviceId: '',
  deviceLanguageCode: '',
  deviceName: '',
  deviceTemplateCode: '',
  deviceTypeCode: '',
  floorCode: '',
  languagesCodes: [],
  storeId: null,
  storeName: '',
  zoneCode: '',
  direction: 'Espacio Movistar',
  experienceSlides: {},
  allowGeolocation: true,
  allowGeolocationRange: null,
  deviceLongitude: null,
  deviceLatitude: null,
  deviceRange: null,
  deviceRangeModal: false,
  deviceRangeTimeout: false,
  devicePwaAllow: true,
  showPlace: false,
  goAppointmentVar: false,
  tme: null,
  codeTransaction: null,
  bannerSlides: {},
  venueMap: []
}

// getters
const getters = {
  getDeviceId(state) {
    return state.deviceId
  },
  getAllowGeolocation(state) {
    return state.allowGeolocation
  },
  getAllowGeolocationRange(state) {
    return state.allowGeolocationRange
  },
  getDeviceLongitude(state) {
    return state.deviceLongitude
  },
  getDeviceLatitude(state) {
    return state.deviceLatitude
  },
  getDeviceRange(state) {
    return state.deviceRange
  },
  getDeviceRangeModal(state) {
    return state.deviceRangeModal
  },
  getDeviceRangeTimeout(state) {
    return state.deviceRangeTimeout
  },
  getdevicePwaAllow(state) {
    return state.devicePwaAllow
  },
  getShowPlace(state) {
    return state.showPlace
  },
  getStoreId(state) {
    return state.storeId
  },
  getTme(state) {
    return state.tme
  },
  getCodeTransaction(state) {
    return state.codeTransaction
  },
  getBannerSlides(state){
    return state.bannerSlides
  },
  getVenueMap(state) {
    return state.venueMap
  }
}

// actions
const actions = {
  async getDeviceInfo({ commit, rootState, dispatch }) {
    try {
      let url = process.env.VUE_APP_PATH + 'getDeviceInfo'
      const response = await axios.get(url, {
        params: {
          deviceId: rootState.common.deviceId
        }
      })

      dispatch('updateDeviceLanguageCode', response.data.language_code)
      commit('setDeviceName', response.data.deviceName)
      commit('setDeviceTemplateCode', response.data.deviceTemplateCode)
      commit('setDeviceTypeCode', response.data.deviceTypeCode)
      commit('setFloorCode', response.data.floorCode)
      commit('setLanguagesCodes', response.data.language_codes)
      commit('setStoreId', response.data.tienda_id)
      commit('setStoreName', response.data.tienda_desc)
      commit('setSessionTimeout', response.data.timeout_sesion)
      commit('setZoneCode', response.data.zoneCode)
      commit('setExperienceSlides', experienceSlidesCommon)
      commit('setDeviceLatitude', response.data.latitude)
      commit('setDeviceLongitude', response.data.longitude)
      commit('setDeviceRange', response.data.range)

      return response
    } catch (err) {
      console.log(err)
      return err
    }
  },
  async registerNavigation(
    { state, rootState },
    { action, name, typeFilter, typeSection, productId, searchResults }
  ) {
    try {
      let url = process.env.VUE_APP_PATH + 'createNavigation'
      await axios.post(url, {
        shopId: state.storeId,
        typeSectionCode: typeSection,
        user: null,
        actionCode: action,
        kioskMac: state.deviceId,
        sesionId: rootState.session.sessionId,
        name: name,
        productId: productId,
        searchResults: searchResults,
        typeFilter: typeFilter
      })
    } catch (err) {
      console.log(err)
    }
  },
  async notificationGranted({ commit }, value) {
    commit('setNotificationAllow', value)
  },
  async bannerSlidesData({ commit }) {
    try {
      let url = process.env.VUE_APP_PATH + 'banners/available'
      const currentDate = new Date().toISOString();
      const response = await axios.get(url, {
        params: {
          typeName: 'WEB',
          date: currentDate
        }
      })

      commit('setBannerSlides', response.data); // Guardamos los datos tal como los recibimos
    } catch (error) {
      console.error('Error loading slider data:', error);
      throw error;
    }
  },
  /*
   * Las plantas del edificio y sus zonas: «Descubre el espacio».
   *
   * Antes esta seccion no pedia nada —la lista de tarjetas estaba escrita en
   * Home.vue y los textos venian compilados dentro—, asi que editarla en el
   * gestor no se veia hasta reconstruir la web.
   *
   * Si falla, se deja la lista vacia y la seccion no se pinta. No hay copia de
   * respaldo dentro del bundle a proposito: una seccion que se sigue viendo
   * cuando el API no contesta ensena lo que habia el dia que se compilo, y eso
   * es peor que no ensenar nada porque nadie se entera.
   */
  async venueMapData({ commit }) {
    try {
      const response = await axios.get(process.env.VUE_APP_PATH + 'venue/map')

      commit('setVenueMap', response.data.data || [])
    } catch (error) {
      console.error('Error loading venue map:', error)
      commit('setVenueMap', [])
    }
  },
  updateGeolocationPermission({ commit }, value) {
    commit('setGeolocationPermission', value)
  },
  updateGeolocationRangePermission({ commit }, value) {
    commit('setGeolocatioRangePermission', value)
  },
  updateGeolocationRangeModal({ commit }, value) {
    commit('setDeviceRangeModal', value)
  },
  updateGeolocationRangeTimeout({ commit }, value) {
    commit('setDeviceRangeTimeout', value)
  },
  updateDevicePwaAllow({ commit }, value) {
    commit('setDevicePwaAllow', value)
  },
  updateShowPlace({ commit }, value) {
    commit('setShowPlace', value)
  },
  updateDeviceId({ commit }, value) {
    commit('setDeviceId', value)
    session.actions.updateFieldsSessionLocalStorage('deviceId', value)
  },
  updateDeviceLanguageCode({ commit }, value) {
    commit('setDeviceLanguageCode', value)
    session.actions.updateFieldsSessionLocalStorage('deviceLanguageCode', value)
  },
  updateTme({ commit }, value) {
    commit('setTme', value)
  },
  updateCodeTransaction({ commit }, value) {
    commit('setCodeTransaction', value)
  }
}

// mutations
const mutations = {
  setDeviceId(state, value) {
    state.deviceId = value
    session.actions.updateFieldsSessionLocalStorage('deviceId', value)
  },
  setDeviceLanguageCode(state, value) {
    state.deviceLanguageCode = value
  },
  setDeviceName(state, value) {
    state.deviceName = value
  },
  setDeviceTemplateCode(state, value) {
    state.deviceTemplateCode = value
  },
  setDeviceTypeCode(state, value) {
    state.deviceTypeCode = value
  },
  setFloorCode(state, value) {
    state.floorCode = value
  },
  setLanguagesCodes(state, value) {
    state.languagesCodes = value
  },
  setStoreId(state, value) {
    state.storeId = value
  },
  setStoreName(state, value) {
    state.storeName = value
  },
  setZoneCode(state, value) {
    state.zoneCode = value
  },
  setExperienceSlides(state, value) {
    state.experienceSlides = value
  },
  setGeolocationPermission(state, value) {
    state.allowGeolocation = value
  },
  setNotificationAllow(state, value) {
    state.notificationAllow = value
  },
  setGeolocatioRangePermission(state, value) {
    state.allowGeolocationRange = value
  },
  setDeviceLatitude(state, value) {
    state.deviceLatitude = value
  },
  setDeviceLongitude(state, value) {
    state.deviceLongitude = value
  },
  setDeviceRange(state, value) {
    state.deviceRange = value
  },
  setDeviceRangeModal(state, value) {
    state.deviceRangeModal = value
  },
  setDeviceRangeTimeout(state, value) {
    state.deviceRangeTimeout = value
  },
  setDevicePwaAllow(state, value) {
    state.devicePwaAllow = value
  },
  setShowPlace(state, value) {
    state.showPlace = value
  },
  setGoAppointmentVar(state, value) {
    state.goAppointmentVar = value
  },
  setTme(state, value) {
    state.tme = value
  },
  setCodeTransaction(state, value) {
    state.codeTransaction = value
  },
  setBannerSlides(state, value){
    state.bannerSlides = value
  },
  setVenueMap(state, value) {
    state.venueMap = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
